// import { IIngredient, ISearchIngredient, ISimiliarIngredient } from "../../interfaces/ingredient";
// import { ActionType } from "../actions/action";
// import { ingredients } from "../actions/actionContants";
// import { IPaginateList } from "../../interfaces/pagination";
// import { IPersona } from "../../interfaces/persona";
// import { PAGINATION_META_DEFAULT } from "../../utils/constants";

// export interface IIngredientState {
// 	ingredients: IPaginateList<IIngredient[]>;
// 	searchIngredients: ISearchIngredient[];
// 	searchPaginatedIngredients: IPaginateList<ISearchIngredient[]>;
// 	selected: IIngredient | null;
// 	selectedPersonas: IPersona[];
// 	selectedSimiliarIngredients: ISimiliarIngredient[];
// 	recentlyViewed: any[];
// 	starred: any[];
// 	search: IIngredient[];
// 	selectedStatus: boolean;
// 	ingredientUsage?: any;
// 	buyersPreview?: any[];
// 	recommendation: {
// 		old: IIngredient | null;
// 		new: IIngredient | null;
// 	};
// 	searchTerm: string;
// }

// const INIT_STATE: IIngredientState = {
// 	ingredients: {
// 		list: [],
// 		pagination: {
// 			page: 1,
// 			pages: 0,
// 			size: 20,
// 			total: 0
// 		}
// 	},
// 	searchIngredients: [],
// 	searchPaginatedIngredients: {
// 		list: [],
// 		pagination: PAGINATION_META_DEFAULT
// 	},
// 	recentlyViewed: [],
// 	selected: null,
// 	starred: [],
// 	search: [],
// 	selectedPersonas: [],
// 	selectedSimiliarIngredients: [],
// 	selectedStatus: false,
// 	ingredientUsage: {},
// 	buyersPreview: [],
// 	recommendation: {
// 		old: null,
// 		new: null
// 	},
// 	searchTerm: ""
// };

// export default function (state: IIngredientState = INIT_STATE, action: ActionType) {
// 	// return state;
// 	switch (action.type) {
// 		case ingredients.INGREDIENTS_RESPONSE:
// 			console.log("Reducer INGREDIENTS_RESPONSE payload:", action.payload);
// 			return {
// 				...state,
// 				ingredients: action.payload
// 			};
// 		case ingredients.PAGINATE_INGREDIENTS:
// 			return {
// 				...state,
// 				ingredients: {
// 					...state.ingredients,
// 					pagination: {
// 						...state.ingredients.pagination,
// 						page: action.payload
// 					}
// 				}
// 			};
// 		case ingredients.GET_STARRED_INGREDIENTS_RESPONSE:
// 			return {
// 				...state,
// 				starred: action.payload
// 			};
// 		case ingredients.GET_INGREDIENT_DETAIL_RESPONSE:
// 			return {
// 				...state,
// 				selected: action.payload
// 			};
// 		case ingredients.GET_INGREDIENT_STATUS_RESPONSE:
// 			return {
// 				...state,
// 				selectedStatus: action.payload
// 			};
// 		case ingredients.GET_INGREDIENT_PERSONA_RESPONSE:
// 			return {
// 				...state,
// 				selectedPersonas: action.payload
// 			};

// 		case ingredients.GET_SIMILIAR_INGREDIENTS_RESPONSE:
// 			return {
// 				...state,
// 				selectedSimiliarIngredients: action.payload
// 			};
// 		case ingredients.GET_SIMILIAR_INGREDIENTS_RESPONSE:
// 			return {
// 				...state,
// 				selectedSimiliarIngredients: action.payload
// 			};
// 		case ingredients.GET_RECENTLY_VIEWED_INGREDIENT_RESPONSE:
// 			return {
// 				...state,
// 				recentlyViewed: action.payload.slice(0, 10)
// 			};
// 		case ingredients.INGREDIENTS_SEARCH_RESPONSE:
// 			return {
// 				...state,
// 				searchIngredients: action.payload
// 			};
// 		case ingredients.GET_INGREDIENT_USAGE:
// 			return {
// 				...state,
// 				ingredientUsage: action.payload
// 			};
// 		case ingredients.GET_BUYERS_PREVIEW:
// 			return {
// 				...state,
// 				buyersPreview: action.payload
// 			};
// 		case ingredients.SET_SEARCH_TERM: // New action type
// 			return {
// 				...state,
// 				searchTerm: action.payload
// 			};
// 		default:
// 			return state;
// 	}
// }
import { IIngredient, ISearchIngredient, ISimiliarIngredient } from "../../interfaces/ingredient";
import { ActionType } from "../actions/action";
import { ingredients } from "../actions/actionContants";
import { IPaginateList } from "../../interfaces/pagination";
import { IPersona } from "../../interfaces/persona";
import { PAGINATION_META_DEFAULT } from "../../utils/constants";

export interface IIngredientState {
    ingredients: IPaginateList<IIngredient[]> & { cache: { [page: number]: IIngredient[] } };
    isLoaded: boolean;
    isRecentlyViewedLoaded: boolean;
    isStarredLoaded: boolean;
    searchIngredients: ISearchIngredient[];
    searchPaginatedIngredients: IPaginateList<ISearchIngredient[]>;
    selected: IIngredient | null;
    selectedPersonas: IPersona[];
    selectedSimiliarIngredients: ISimiliarIngredient[];
    recentlyViewed: any[];
    starred: any[];
    search: IIngredient[];
    selectedStatus: boolean;
    ingredientUsage?: any;
    buyersPreview?: any[];
    recommendation: {
        old: IIngredient | null;
        new: IIngredient | null;
    };
    searchTerm: string;
}

const INIT_STATE: IIngredientState = {
    ingredients: {
        list: [],
        pagination: {
            page: 1,
            pages: 0,
            size: 20,
            total: 0
        },
        cache: {}
    },
    isLoaded: false,
    isRecentlyViewedLoaded: false,
    isStarredLoaded: false,
    searchIngredients: [],
    searchPaginatedIngredients: {
        list: [],
        pagination: PAGINATION_META_DEFAULT
    },
    recentlyViewed: [],
    selected: null,
    starred: [],
    search: [],
    selectedPersonas: [],
    selectedSimiliarIngredients: [],
    selectedStatus: false,
    ingredientUsage: {},
    buyersPreview: [],
    recommendation: {
        old: null,
        new: null
    },
    searchTerm: ""
};

export default function ingredientReducer(state: IIngredientState = INIT_STATE, action: ActionType) {
    switch (action.type) {
        case ingredients.INGREDIENTS_RESPONSE:
            return {
                ...state,
                ingredients: {
                    ...action.payload,
                    cache: {
                        ...state.ingredients.cache,
                        [action.payload.pagination.page]: action.payload.list
                    }
                },
                isLoaded: true
            };
        case ingredients.PAGINATE_INGREDIENTS:

            // Expect action.payload to be a number for the new page
            return {
                ...state,
                ingredients: {
                    ...state.ingredients,
                    pagination: {
                        ...state.ingredients.pagination,
                        page: action.payload
                    }
                }
            };
        case ingredients.SET_INGREDIENT_PAGINATION:
            // Handle setting pagination (page, size, etc.)
            return {
                ...state,
                ingredients: {
                    ...state.ingredients,
                    pagination: {
                        ...state.ingredients.pagination,
                        ...action.payload
                    }
                }
            };
        case ingredients.GET_STARRED_INGREDIENTS_RESPONSE:
            return {
                ...state,
                starred: action.payload,
                isStarredLoaded: true
            };
        case ingredients.GET_INGREDIENT_DETAIL_RESPONSE:
            return {
                ...state,
                selected: action.payload
            };
        case ingredients.GET_INGREDIENT_STATUS_RESPONSE:
            return {
                ...state,
                selectedStatus: action.payload
            };
        case ingredients.GET_INGREDIENT_PERSONA_RESPONSE:
            return {
                ...state,
                selectedPersonas: action.payload
            };
        case ingredients.GET_SIMILIAR_INGREDIENTS_RESPONSE:
            return {
                ...state,
                selectedSimiliarIngredients: action.payload
            };
        case ingredients.GET_RECENTLY_VIEWED_INGREDIENT_RESPONSE:
            return {
                ...state,
                recentlyViewed: action.payload?.slice(0, 10) || [],
                isRecentlyViewedLoaded: true
            };
        case ingredients.INGREDIENTS_SEARCH_RESPONSE:
            return {
                ...state,
                searchIngredients: action.payload
            };
        case ingredients.GET_INGREDIENT_USAGE:
            return {
                ...state,
                ingredientUsage: action.payload
            };
        case ingredients.GET_BUYERS_PREVIEW:
            return {
                ...state,
                buyersPreview: action.payload
            };
        case ingredients.SET_SEARCH_TERM:
            return {
                ...state,
                searchTerm: action.payload
            };
        default:
            return state;
    }
}